import React from 'react';
import { useRouting } from './useRouting';
import './RoutingInfo.css';

const RoutingInfo: React.FC = () => {
  const { currentApp, isInPortal } = useRouting();

  if (!isInPortal()) {
    return null; // No mostrar en las apps
  }

  return (
    <div className="routing-info">
      <div className="routing-info-content">
        <h3>Acceso Directo por URL</h3>
        <p>Puedes acceder directamente a las aplicaciones usando estas URLs:</p>
        <div className="url-list">
          <div className="url-item">
            <strong>BIM Catastro:</strong>
            <code>http://localhost:3000/bim-catastro</code>
          </div>
          <div className="url-item">
            <strong>IFC Tools:</strong>
            <code>http://localhost:3000/</code>
          </div>
        </div>
        <p className="routing-note">
          💡 <strong>Tip:</strong> Puedes marcar estas URLs como favoritos para acceso rápido.
        </p>
      </div>
    </div>
  );
};

export default RoutingInfo;
